<template>
  <zg-module
    v-bind="moduleProps"
    class="zg-tips-section"
  >
    <slot
      slot="sub-title"
      name="sub-title"
    />

    <div>
      <zg-tips-line
        :tips="tips"
      />
    </div>
  </zg-module>
</template>

<script>
  import module from '../../../mixins/module.js'
  import ZgTipsLine from '../../ZgTipsLine/ZgTipsLine.vue'
  import ZgModule from '../ZgModule/ZgModule.vue'

  export default {
    name: 'ZgTipsSection',
    components: {
      ZgModule,
      ZgTipsLine
    },
    mixins: [module],
    props: {
      tips: {
        type: Array,
        required: true
      }
    }
  }
</script>
